import React from 'react'
import ViewRedirections from '../../Components/Redirections/ViewRedirections'

const ViewRedirectionsPage = () => {
  return (
    <ViewRedirections/>
  )
}

export default ViewRedirectionsPage